import type {Badge} from '@/components/badges/config'
import type {PriceIntelligenceVM} from './derive'
/** PDP legacy price badges must share the evidence used by its price modules. */
export function priceEvidenceBadges(badges:Badge[],offer:{priceCents?:number;originalCents?:number;isPriceUnknown?:boolean;isStale?:boolean}|null|undefined,history:Pick<PriceIntelligenceVM,'tier'>|null):Badge[]{
 const valid=!!offer&&!offer.isPriceUnknown&&!offer.isStale&&typeof offer.priceCents==='number'&&Number.isSafeInteger(offer.priceCents)&&offer.priceCents>0
 const listed=valid&&typeof offer.originalCents==='number'&&Number.isSafeInteger(offer.originalCents)&&offer.originalCents>offer.priceCents
 return badges.flatMap(badge=>{
  if(badge.type!=='price_drop')return [badge]
  // This label is earned only by the independently gated historical verdict.
  const label=valid&&history?.tier==='all-time-low'?'Lowest tracked price':valid&&history?.tier==='below-average'?'Below tracked average':listed?'Listed discount':null
  // Legacy savings metadata may use a different/unaudited comparison basis.
  if(!label)return []
  const {meta,...rest}=badge
  return [{...rest,label}]
 })
}
